import { FC, SVGProps } from 'react'

export const BookOpen: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M2.69767 3C2.31236 3 2 3.31236 2 3.69767V17.6511C2 18.0364 2.31236 18.3487 2.69767 18.3487H9.20926C9.76436 18.3487 10.2967 18.5693 10.6892 18.9618C11.0818 19.3543 11.3023 19.8867 11.3023 20.4418C11.3023 20.803 11.5768 21.1001 11.9286 21.1358C11.9521 21.1382 11.9759 21.1394 11.9999 21.1394C12 21.1394 12 21.1394 12.0001 21.1394C12.3854 21.1394 12.6977 20.8271 12.6977 20.4418C12.6977 19.8867 12.9183 19.3543 13.3108 18.9618C13.7033 18.5693 14.2357 18.3487 14.7908 18.3487H21.3023C21.6877 18.3487 22 18.0364 22 17.6511V3.69767C22 3.31236 21.6877 3 21.3023 3H15.721C14.5491 3 13.4252 3.46553 12.5966 4.29417C12.3698 4.52091 12.1703 4.76976 12 5.03565C11.8297 4.76976 11.6302 4.52091 11.4034 4.29417C10.5748 3.46553 9.45091 3 8.27903 3H2.69767ZM11.3023 7.41858V17.6511C10.702 17.2008 9.96839 16.9534 9.20926 16.9534H3.39534V4.39534H8.27903C9.08085 4.39534 9.84982 4.71386 10.4168 5.28083C10.9838 5.84779 11.3023 6.61677 11.3023 7.41858ZM14.7908 16.9534C14.0316 16.9534 13.298 17.2008 12.6977 17.6511V7.41858C12.6977 6.61677 13.0163 5.84779 13.5832 5.28083C14.1502 4.71386 14.9192 4.39534 15.721 4.39534H20.6047V16.9534H14.7908Z"
			fill="currentColor"
		/>
	</svg>
)
